"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommissionPayoutRequest = void 0;
const legacy_enums_1 = require("@daytrip/legacy-enums");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const type_graphql_1 = require("type-graphql");
const typeorm_1 = require("typeorm");
const transformToDate_1 = require("../transformers/transformToDate");
const CommissionPayoutOrder_1 = require("./CommissionPayoutOrder");
let CommissionPayoutRequest = class CommissionPayoutRequest {
    _id;
    travelAgentId;
    name;
    email;
    totalAmount;
    currency;
    createdAt;
    updatedAt;
    status;
    declinationNote;
    commissionPayoutOrders;
};
exports.CommissionPayoutRequest = CommissionPayoutRequest;
__decorate([
    (0, typeorm_1.ObjectIdColumn)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", String)
], CommissionPayoutRequest.prototype, "_id", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, type_graphql_1.Field)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], CommissionPayoutRequest.prototype, "travelAgentId", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", String)
], CommissionPayoutRequest.prototype, "name", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsEmail)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", String)
], CommissionPayoutRequest.prototype, "email", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsNumber)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    __metadata("design:type", Number)
], CommissionPayoutRequest.prototype, "totalAmount", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.Currency),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], CommissionPayoutRequest.prototype, "currency", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, type_graphql_1.Field)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], CommissionPayoutRequest.prototype, "createdAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, type_graphql_1.Field)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    transformToDate_1.TransformToDate,
    __metadata("design:type", Date)
], CommissionPayoutRequest.prototype, "updatedAt", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, type_graphql_1.Field)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsEnum)(legacy_enums_1.CommissionPayoutRequestStatus),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], CommissionPayoutRequest.prototype, "status", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, type_graphql_1.Field)({ nullable: true }),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsOptional)(),
    __metadata("design:type", String)
], CommissionPayoutRequest.prototype, "declinationNote", void 0);
__decorate([
    (0, typeorm_1.Column)(),
    (0, type_graphql_1.Field)(() => CommissionPayoutOrder_1.CommissionPayoutOrder),
    (0, class_validator_1.IsArray)(),
    (0, class_transformer_1.Expose)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => CommissionPayoutOrder_1.CommissionPayoutOrder),
    (0, class_validator_1.ValidateNested)({ each: true }),
    __metadata("design:type", Array)
], CommissionPayoutRequest.prototype, "commissionPayoutOrders", void 0);
exports.CommissionPayoutRequest = CommissionPayoutRequest = __decorate([
    (0, class_transformer_1.Exclude)(),
    (0, typeorm_1.Entity)("commissionPayoutRequests"),
    (0, type_graphql_1.ObjectType)("CommissionPayoutRequest"),
    (0, type_graphql_1.InputType)("CommissionPayoutRequest")
], CommissionPayoutRequest);
//# sourceMappingURL=CommissionPayoutRequest.js.map